export enum PreviewSize {
    width = 135,
    height = 240,
}

export enum PreviewAspectRatio {
    nineSixteen = "9:16",
    threeFour = "3:4",
}

export enum PreviewResolution {
    minNineSixteen = "720x1280",
    minThreeFour = "480x640",
}
